import { render, staticRenderFns } from "./DocPagination.vue?vue&type=template&id=3cf652b4&scoped=true"
import script from "./DocPagination.vue?vue&type=script&lang=js"
export * from "./DocPagination.vue?vue&type=script&lang=js"
import style0 from "./DocPagination.vue?vue&type=style&index=0&id=3cf652b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf652b4",
  null
  
)

export default component.exports